import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import { SelectControl } from '@wordpress/components';
import InspectorResponsiveLabel2, {
	valueToMediaValue,
	mediaValueToValue,
} from '../inspector-responsive-label-2';

function toTitleCase( str ) {
	if ( ! str ) return '';
	return str.charAt( 0 ).toUpperCase() + str.slice( 1 ).toLowerCase();
}

const InspectorSelectRowResponsive = ( props ) => {
	const {
		label,
		value,
		options,
		onChange = () => {},
		isResetButton = false,
		isMedia = true,
		isUnit = false,
	} = props;

	const deviceType = useSelect( ( select ) => {
		const store = select( 'core/edit-post' );
		const editorStore = select( 'core/editor' );
		let device = '';
		if (
			store &&
			typeof store.__experimentalGetPreviewDeviceType === 'function'
		) {
			device = store.__experimentalGetPreviewDeviceType();
		} else if (
			editorStore &&
			typeof editorStore.getDeviceType === 'function'
		) {
			device = editorStore.getDeviceType();
		}
		return device;
	}, [] );

	const currentMedia = toTitleCase( deviceType ) || 'Desktop';

	return (
		<>
			<div className="flex items-stretch justify-between gap-1 flex-col">
				<InspectorResponsiveLabel2
					label={ label ?? 'Default Label' }
					isResetButton={ isResetButton }
					isMedia={ isMedia }
					isUnit={ isUnit }
				/>
				<div>
					<SelectControl
						onChange={ ( val ) =>
							onChange(
								valueToMediaValue( val, currentMedia, value )
							)
						}
						className="border-style"
						value={ mediaValueToValue( value, currentMedia ) }
						options={ options }
						__next40pxDefaultSize
						__nextHasNoMarginBottom
					/>
				</div>
			</div>
		</>
	);
};

export default InspectorSelectRowResponsive;
